export const Footer = () => {
  return <div></div>;
};
